export default {
  // 获取基础信息，使用深拷贝，避免污染源数据
  getBasic: state => JSON.parse(JSON.stringify(state.basicInfo)),
  getBasicBgList: state => JSON.parse(JSON.stringify(state.basicInfoBgList)),
  // 获取页面包列表信息
  packagesGetter: state => {
    const packages = JSON.parse(JSON.stringify(state.packages))
    return packages.map(item => {
      if (item.pageInfo && item.pageInfo.length && item.pageInfo[0].source_type == 2) {
        // 若页面包中的页面是素材，在页面包中增加一个source_type字段，表明页面包中的页面都是素材
        // 因为页面包中都是素材时不能和其他类型页面组合，所以判断第一个页面是素材即可
        item.source_type = item.pageInfo[0].source_type
      } else if (item.pageInfo && item.pageInfo.length && item.pageInfo[0].source_id != 0 && item.pageInfo[0].source_type != 2) {
        // 页面包中第一个页面为试题：source_id != 0 && source_type != 2
        // 在页面包中增加试题标志字段
        item.isTest = true
      }
      item.newName = item.name
      return item
    })
  },
  // 获取课件基础信息
  coursewareInfoGetter: state => JSON.parse(JSON.stringify(state.coursewareInfo)),
  // 获取某一个页面包的信息
  onePackageInfoGetter: (state) => (id) => {
    const target = state.packages.find(item => item.id === id)
    if (target) {
      return target
    } else {
      return {}
    }
  },
  // 获取不包含编程和语音答题的属性
  nonProgrammeVoiceAttr: (state) => {
    return state.basicInfo.packageAttr.filter(item => (item.package_attr != 9 && item.package_attr != 8))
  },
  // 获取包含编程的属性
  programmeAttr: (state) => {
    return state.basicInfo.packageAttr.filter(item => item.package_attr != 8)
  },
  // 获取包含语音答题的属性
  voiceAttr: (state) => {
    return state.basicInfo.packageAttr.filter(item => item.package_attr != 9)
  },
  // 获取课件列表筛选参数
  filterDataGetter: (state) => JSON.parse(JSON.stringify(state.filterData))
}



// WEBPACK FOOTER //
// ./src/store/courseware/getters.js